export default "ui-textcounter{display:block}@media screen and (max-width:767px){ui-textcounter{width:100%}}\n";